<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="Create Coupon"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Coupon' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="12" md="12">
        <b-card>
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="promoCode"
                      >Coupon Code
                      <i
                        id="button-1"
                        class="fas fa-question-circle help-icon"
                      >
                        <b-tooltip
                          target="button-1"
                          placement="topright"
                          triggers="hover"
                          >Enter Coupon Code like COUPON2021,
                          NEWYEAROFFER.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Coupon Code"
                    >
                      <b-form-input
                        class="custom-transform-class"
                        id="promoCode"
                        @keydown="validateCode"
                        inputType="text"
                        v-model="inputObject.promoCode"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="categoryOptions"
                      >Applicable On
                      <i
                        id="Applicable"
                        class="fas fa-question-circle help-icon"
                      ></i
                      ><b-tooltip
                        target="Applicable"
                        placement="topright"
                        triggers="hover"
                        >Select “Order” from Applicable On</b-tooltip
                      >
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Applicable On"
                    >
                      <eb-select
                        id="categoryOptions"
                        type="text"
                        label="label"
                        v-model="inputObject.applicableOn"
                        :options="categoryOptions"
                        @input="fetchAllPartnerList()"
                        placeholder="Select applicableOn"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="inputObject.applicableOn.value === 'CATALOG'"
                >
                  <div class="form-group">
                    <label for="catalog-id">Catalog</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Catalog"
                    >
                      <eb-select
                        id="catalog-id"
                        type="text"
                        label="text"
                        :options="catalogList"
                        v-model="inputObject.catalogId"
                        placeholder="Select Catalog"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <!-- <b-col cols="12" sm="12" md="4" v-if="inputObject.applicableOn.value === 'ITEM'">
                  <b-row>
                    <b-col col="12">
                      <div class="form-group">
                        <label for="catalog-id">Catalog</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Catalog"
                        >
                          <eb-select
                            id="catalog-id"
                            type="text"
                            label="text"
                            :options="catalogList"
                            v-model="inputObject.catalogId"
                            placeholder="Select Item catalog"
                            @input="itemCatalogSelected"
                          ></eb-select>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="inputObject.catalogId && itemsList.length">
                    <b-col col="12">
                      <div class="form-group">
                        <label for="item-id">Item</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          name="Item"
                        >
                          <eb-select
                            id="item-id"
                            type="text"
                            label="text"
                            :options="itemsList"
                            v-model="inputObject.itemId"
                            placeholder="Select Item"
                            @input="onchangeItem"
                            value="value"
                          ></eb-select>
                          <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </b-col>
                  </b-row>
                </b-col> -->
                <b-col
                  md="4"
                  v-if="
                    inputObject.applicableOn.value === 'PARTNER' &&
                    userRole === 'Tenant'
                  "
                >
                  <div class="form-group">
                    <label for="selectSeller">Partner </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Partner"
                    >
                      <eb-select
                        type="text"
                        :id="'selectSeller'"
                        v-model="currentProvider"
                        :options="partnerList"
                        label="name"
                        placeholder="Select Partner"
                      ></eb-select>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <label for="title"
                      >Title
                      <i
                        id="title"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="title"
                          placement="topright"
                          triggers="hover"
                          >Insert “Title” like COUPON2021,
                          NEWYEAROFFER.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Title"
                    >
                      <textarea
                        rows="4"
                        cols="30"
                        id="title"
                        class="form-control custom-transform-class"
                        inputType="text"
                        maxlength="300"
                        v-model="inputObject.title"
                      ></textarea>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="description"
                      >Description
                      <i
                        id="Description"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="Description"
                          placement="topright"
                          triggers="hover"
                          >Get a reward of Rs.100 off on purchase of Rs.600 with
                          an attached this coupon.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="description"
                    >
                      <textarea
                        rows="4"
                        cols="30"
                        class="form-control"
                        id="description"
                        inputType="text"
                        maxlength="1500"
                        v-model="inputObject.description"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="startdate"
                      >Start Date
                      <i
                        placement="topright"
                        id="startdate"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="startdate"
                          placement="topright"
                          triggers="hover"
                          >Select start date from calendar dropdown.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required|futureDate"
                      v-slot="{ errors }"
                      name="Start Date"
                    >
                      <b-input
                        id="startdate"
                        type="date"
                        v-model="inputObject.startDate"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="enddate"
                      >End Date
                      <i
                        placement="topright"
                        id="enddate"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="enddate"
                          placement="topright"
                          triggers="hover"
                          >Select End date from calendar dropdown.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required|afterDate:startDate"
                      v-slot="{ errors }"
                      name="End Date"
                    >
                      <b-input
                        id="enddate"
                        type="date"
                        v-model="inputObject.endDate"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="maxRewardValue"
                      >Max Reward Value
                      <i
                        placement="topright"
                        id="Max"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="Max"
                          placement="topright"
                          triggers="hover"
                          >Enter maximum reward value like 50,100.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Max Reward Value"
                    >
                      <b-form-input
                        id="maxRewardValue"
                        inputType="text"
                        maxlength="100"
                        v-model="inputObject.maxRewardValue"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <div class="form-group">
                    <label for="minimumAmountExcludingTax"
                      >Minimum Amount Excluding Tax
                      <i
                        placement="topright"
                        id="MinimumAmount"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="MinimumAmount"
                          placement="topright"
                          triggers="hover"
                          >Minimum value required to apply Coupon
                          Code.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Minimum Amount Excluding Tax"
                    >
                      <b-form-input
                        id="minimumAmountExcludingTax"
                        inputType="text"
                        maxlength="100"
                        v-model="inputObject.minimumAmountExcludingTax"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label
                      for="rewardValue"
                      v-if="inputObject.discountType.value === 'Percentage'"
                      >Reward Percentage</label
                    >
                    <label for="rewardValue" v-else
                      >Reward Value
                      <i
                        placement="topright"
                        id="Reward"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="Reward"
                          placement="topright"
                          triggers="hover"
                          >Reward Value should be less or equal to Maximum
                          Reward Value.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Reward Value"
                    >
                      <b-input
                        id="rewardValue"
                        type="text"
                        v-model="inputObject.rewardValue"
                      ></b-input>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <label for="within"
                      >Frequency in minutes
                      <i
                        placement="topright"
                        id="Frequency"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="Frequency"
                          placement="topright"
                          triggers="hover"
                          >Number of times to apply coupon code per minute by
                          Customer like 5, 7 etc.</b-tooltip
                        ></i
                      ></label
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Timing Rules"
                    >
                      <b-form-input
                        id="within"
                        inputType="text"
                        v-model="timingRules.within"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <div>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="discountType"
                        >Discount Type
                        <i
                          placement="topright"
                          id="discountType"
                          class="fas fa-question-circle help-icon"
                          ><b-tooltip
                            target="discountType"
                            placement="topright"
                            triggers="hover"
                            >Select “Number” from Discount Type
                            dropdown.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Discount Type"
                      >
                        <eb-select
                          id="discountType"
                          type="text"
                          label="label"
                          v-model="inputObject.discountType"
                          :options="discountType"
                          placeholder="Select discount type"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="rewardType"
                        >Reward Type
                        <i
                          id="rewardType"
                          class="fas fa-question-circle help-icon"
                        >
                          <b-tooltip
                            target="rewardType"
                            placement="topright"
                            triggers="hover"
                            >Reward Type should be Discount.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        id="rewardType"
                        type="text"
                        label="label"
                        v-model="inputObject.rewardType"
                        :options="rewardType"
                        placeholder="Select reward type"
                      ></eb-select>
                    </div>
                  </b-col>
                  <b-col
                    md="4"
                    v-if="inputObject.rewardType.value === 'Wallet'"
                  >
                    <div class="form-group">
                      <label for="rewardBalanceType"
                        >Reward Balance Type
                        <i
                          id="rewardBalanceType"
                          class="fas fa-question-circle help-icon"
                        >
                          <b-tooltip
                            target="rewardBalanceType"
                            placement="topright"
                            triggers="hover"
                            >Reward Balance Type.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        id="rewardBalanceType"
                        type="text"
                        label="name"
                        v-model="inputObject.rewardBalanceType"
                        :options="rewardBalanceType"
                        placeholder="Select reward Balance type"
                      ></eb-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="inputObject.rewardType.value === 'Wallet'">
                  <b-col md="4">
                    <div class="form-group">
                      <label for="expiryValue"
                        >Enter Expiry
                        <i
                          id="expiryValue"
                          class="fas fa-question-circle help-icon"
                        >
                          <b-tooltip
                            target="expiryValue"
                            placement="topright"
                            triggers="hover"
                            >Time period for Expiry of the Coupon as
                            1,2,3.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Expiry"
                      >
                        <b-form-input
                          class="custom-transform-class"
                          id="expiryValue"
                          inputType="number"
                          placeholder="Enter Expiry Value"
                          v-model="inputObject.value"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="uom"
                        >UOM
                        <i
                          id="uom"
                          class="fas fa-question-circle help-icon"
                        >
                          <b-tooltip
                            target="uom"
                            placement="topright"
                            triggers="hover"
                            >Select Expiry Date UOM as Year, Months,
                            Days.</b-tooltip
                          ></i
                        ></label
                      >
                      <eb-select
                        type="text"
                        v-model="inputObject.uom"
                        :options="['Days', 'Months', 'Years']"
                        label="label"
                        id="uom"
                        class=""
                        placeholder="UOM"
                      ></eb-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="totalLimit"
                        >Total allowed in day
                        <i
                          placement="topright"
                          id="totalLimit"
                          class="fas fa-question-circle help-icon"
                          ><b-tooltip
                            target="totalLimit"
                            placement="topright"
                            triggers="hover"
                            >Number of times coupon code can be used by customer
                            per day likes 5 or 10 times.</b-tooltip
                          ></i
                        ></label
                      >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Timing Rules"
                      >
                        <b-form-input
                          id="totalLimit"
                          inputType="text"
                          v-model="timingRules.totalLimit"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="maxExisting"
                        >Max Existing Orders
                        <i
                          placement="topright"
                          id="maxExisting"
                          class="fas fa-question-circle help-icon"
                          ><b-tooltip
                            target="maxExisting"
                            placement="topright"
                            triggers="hover"
                            >Coupon will work only for people having existing
                            orders less than specified number</b-tooltip
                          ></i
                        ></label
                      >

                      <b-form-input
                        id="maxExisting"
                        inputType="text"
                        v-model="inputObject.maxExistingOrders"
                      />
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-group">
                      <label for="minExiting"
                        >Min Existing Orders
                        <i
                          placement="topright"
                          id="minExiting"
                          class="fas fa-question-circle help-icon"
                          ><b-tooltip
                            target="minExiting"
                            placement="topright"
                            triggers="hover"
                            >Coupon will be available only for those who have
                            this much existing orders.</b-tooltip
                          ></i
                        ></label
                      >
                      <b-form-input
                        id="minExiting"
                        inputType="text"
                        v-model="inputObject.minExistingOrders"
                      />
                    </div>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="maximumQuantity">Maximum Quantity </label>

                          <b-form-input
                            id="maximumQuantity"
                            inputType="text"
                            v-model="inputObject.maxQuantity"
                          />
                        </div>
                      </b-col>
                      <b-col md="4">
                        <div class="form-group">
                          <label for="minimumQuantity">Minimum Quantity </label>

                          <b-form-input
                            id="minimumQuantity"
                            inputType="text"
                            v-model="inputObject.minQuantity"
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="12">
                    <b-row>
                      <b-col md="4">
                        <div class="form-group">
                          <b-form-checkbox switch v-model="showOption"
                            >Location Rule</b-form-checkbox
                          >
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Location label"
                          >
                            <eb-select
                              id="locationSelect"
                              type="text"
                              label="text"
                              :options="['City', 'State']"
                              placeholder="Select Location Label"
                              v-model="inputObject.locationSelected"
                            ></eb-select>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                      <b-col md="4" v-if="showOption === true">
                        <div class="form-group">
                          <label>Location Value</label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Location Value"
                          >
                            <b-form-input
                              inputType="text"
                              id="locationValue"
                              v-model="inputObject.locationValue"
                            >
                            </b-form-input>
                            <span class="validate-error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="12" sm="12" md="4" v-for="(tc, idx) in tc" :key="idx">
                  <div class="form-group">
                    <label for="tc"
                      >Terms and Conditions
                      <i
                        placement="topright"
                        id="Terms"
                        class="fas fa-question-circle help-icon"
                        ><b-tooltip
                          target="Terms"
                          placement="topright"
                          triggers="hover"
                          >Terms and Conditions like 1) This is valid on
                          purchase more than amount 200 2) This is valid for
                          valid period. 3) This is used only no of times per
                          day.</b-tooltip
                        ></i
                      ></label
                    >
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Terms and Conditions"
                    >
                      <textarea
                        id="tc"
                        rows="4"
                        cols="30"
                        class="form-control"
                        inputType="text"
                        maxlength="3000"
                        v-model="tc.tc"
                      ></textarea>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="allowMultiDiscount"
                      >Allow MultiDiscount</b-form-checkbox
                    >
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="promote"
                      >Promote</b-form-checkbox
                    >
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-group">
                    <b-form-checkbox switch v-model="autoApply"
                      >AutoApply</b-form-checkbox
                    >
                  </div>
                </b-col>
              </b-row>
              <hr />
              <div class="text-center mt-3 mb-3">
                <button
                  type="button"
                  class="btn btn-primary wide-button"
                  :disabled="invalid"
                  @click.prevent="handleSubmit"
                >
                  Save
                </button>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  Validator,
} from "vee-validate/dist/vee-validate.esm";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";

// Constants
const APPLICABLE_ON = {
  CATALOG: "CATALOG",
  PARTNER: "PARTNER",
  ITEM: "ITEM",
  ORDER: "ORDER",
  REGISTRATION: "REGISTRATION",
  REFERRAL: "REFERRAL",
};

const LOCATION_TYPE = {
  CITY: "city",
  STATE: "state",
};

const REWARD_TYPE = {
  DISCOUNT: "Discount",
  SHIPPING: "Shipping",
  WALLET: "Wallet",
};

const USER_ROLE = {
  TENANT: "Tenant",
  SELLER: "SELLER",
};

export default {
  name: "CreateCoupon",
  
  components: {
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    ComponentHeader,
  },
  
  data() {
    return {
      showOption: false,
      currentProvider: null,
      allowMultiDiscount: false,
      promote: false,
      autoApply: false,
      timingRules: {
        within: "",
        totalLimit: "",
      },
      inputObject: {
        rewardType: "",
        rewardBalanceType: "",
        uom: "",
        value: 0,
        title: "",
        description: "",
        catalogId: "",
        maxRewardValue: "",
        minimumAmountExcludingTax: "",
        applicableOn: "",
        discountType: "",
        itemId: "",
        tags: [],
        startDate: "",
        endDate: "",
        promoCode: "",
        maxExistingOrders: null,
        minExistingOrders: null,
        minQuantity: null,
        maxQuantity: null,
        locationValue: "",
        locationSelected: "",
      },
      tc: [
        {
          tc: "",
          isRemovable: false,
          text: "Add",
        },
      ],
      catalogList: [
        {
          text: "Select Catalog",
          value: "1",
        },
      ],
      rewardType: [
        {
          label: REWARD_TYPE.DISCOUNT,
          value: REWARD_TYPE.DISCOUNT,
        },
        {
          label: REWARD_TYPE.SHIPPING,
          value: REWARD_TYPE.SHIPPING,
        },
        {
          label: REWARD_TYPE.WALLET,
          value: REWARD_TYPE.WALLET,
        },
      ],
      discountType: [
        {
          label: "Number",
          value: "Number",
        },
        {
          label: "Percentage",
          value: "Percentage",
        },
      ],
      itemsList: [],
    };
  },
  
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    
    rewardBalanceType() {
      return this.transformStoreData(
        this.$store.getters["partner/GetWalletData"],
        (obj) => ({
          _id: obj.resourceID,
          name: obj.code,
        })
      );
    },
    
    categoryOptions() {
      const isNotSeller = this.$currentUserData?.category !== USER_ROLE.SELLER;
      
      const baseOptions = [
        { label: "Catalog", value: APPLICABLE_ON.CATALOG },
        { label: "Item", value: APPLICABLE_ON.ITEM },
        { label: "Order", value: APPLICABLE_ON.ORDER },
      ];
      
      const additionalOptions = [
        { label: "Partner", value: APPLICABLE_ON.PARTNER },
        { label: "Registration", value: APPLICABLE_ON.REGISTRATION },
        { label: "Referral", value: APPLICABLE_ON.REFERRAL },
      ];
      
      return isNotSeller ? [...baseOptions.slice(0, 1), ...additionalOptions, ...baseOptions.slice(1)] : baseOptions;
    },
    
    partnerList() {
      return this.transformStoreData(
        this.$store.getters["partner/GetPartnerLiteList"],
        (obj) => ({
          _id: obj._id,
          name: obj.organization.name,
          ...obj,
        })
      );
    },
    
    userRole() {
      return (
        this.$store.getters["auth/getUserRole"] ||
        JSON.parse(sessionStorage.getItem("userLogin"))?.role
      );
    },
    
    isTenant() {
      return this.userRole === USER_ROLE.TENANT;
    },
  },
  
  mounted() {
    this.initializeComponent();
  },
  
  methods: {
    ...mapActions({
      Getpartnerlist: "partner/fetchPartnerListLite",
      GetWalletList: "partner/fetchWalletList",
    }),
    
    initializeComponent() {
      this.Getpartnerlist({ type: "" });
      this.getCatalogName();
      this.GetWalletList();
      this.setupValidators();
    },
    
    setupValidators() {
      Validator.extend(
        "afterDate",
        (value) => moment(value).diff(this.inputObject.startDate, "hour") >= 0,
        { hasTarget: true }
      );
      
      Validator.extend(
        "futureDate",
        (value) => moment().diff(this.inputObject.startDate, "day") <= 0,
        { hasTarget: true }
      );
    },
    
    transformStoreData(data, transformer) {
      if (!Array.isArray(data) || data.length === 0) {
        return [];
      }
      return data.map(transformer);
    },
    
    validateCode() {
      // Validation handled by form input
    },
    
    fetchAllPartnerList() {
      const shouldFetchPartners =
        this.inputObject.applicableOn.value === APPLICABLE_ON.PARTNER &&
        this.isTenant &&
        (!Array.isArray(this.partnerList) || this.partnerList.length === 0);
      
      if (shouldFetchPartners) {
        this.Getpartnerlist({ type: "" });
      }
    },
    
    async onClicktcButton(item, idx) {
      if (!item.isRemovable) {
        this.tc.push({
          tc: "",
          isRemovable: true,
          text: "Remove",
        });
      } else {
        this.tc.splice(idx, 1);
      }
    },
    
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      
      const couponData = this.buildCouponData();
      
      await this.saveCoupon(couponData);
      await this.refreshCouponList();
      
      this.$router.push({ name: "Coupon" });
    },
    
    buildCouponData() {
      const data = {
        promoCode: this.inputObject.promoCode.toUpperCase(),
        description: this.inputObject.description,
        title: this.inputObject.title.toUpperCase(),
        promoRules: this.buildPromoRules(),
        timingRules: {
          within: this.timingRules.within,
          totalLimit: this.timingRules.totalLimit,
        },
        tc: this.tc.map((t) => t.tc),
        tags: this.inputObject.tags,
        autoApply: this.autoApply,
        allowMultiDiscount: this.allowMultiDiscount,
        promote: this.promote,
      };
      
      this.addWalletRules(data);
      this.addLocationRules(data);
      this.addApplicableRules(data);
      
      return data;
    },
    
    buildPromoRules() {
      return {
        startDate: this.inputObject.startDate,
        endDate: this.inputObject.endDate,
        maxRewardValue: this.inputObject.maxRewardValue,
        minimumAmountExcludingTax: this.inputObject.minimumAmountExcludingTax,
        rewardValue: this.inputObject.rewardValue,
        discountType: this.inputObject.discountType.value,
        rewardType: this.inputObject.rewardType.value,
        applicableOn: this.inputObject.applicableOn.value,
        maxExistingOrders: this.inputObject.maxExistingOrders,
        minExistingOrders: this.inputObject.minExistingOrders,
        minQuantity: this.inputObject.minQuantity,
        maxQuantity: this.inputObject.maxQuantity,
      };
    },
    
    addWalletRules(data) {
      if (this.inputObject.rewardType.value === REWARD_TYPE.WALLET) {
        data.promoRules.wallet = {
          amountType: {
            key: this.inputObject.rewardBalanceType._id,
            value: this.inputObject.rewardBalanceType.name,
          },
          expireIn: {
            value: +this.inputObject.value,
            uom: this.inputObject.uom,
          },
        };
      }
    },
    
    addLocationRules(data) {
      const locationTypeLower = this.inputObject.locationSelected.toLowerCase();
      
      if (locationTypeLower === LOCATION_TYPE.CITY) {
        data.locationRules = {
          city: this.inputObject.locationValue.toLowerCase(),
        };
      } else if (locationTypeLower === LOCATION_TYPE.STATE) {
        data.locationRules = {
          state: this.inputObject.locationValue.toLowerCase(),
        };
      }
    },
    
    addApplicableRules(data) {
      const applicableOn = this.inputObject.applicableOn.value;
      
      switch (applicableOn) {
        case APPLICABLE_ON.ITEM:
          data.promoRules.itemId = this.inputObject.itemId.value;
          break;
        case APPLICABLE_ON.CATALOG:
          data.promoRules.catalogId = this.inputObject.catalogId.value;
          break;
        case APPLICABLE_ON.PARTNER:
          if (this.isTenant) {
            data.promoRules.providerId = this.currentProvider?._id || null;
          }
          break;
      }
    },
    
    async saveCoupon(data) {
      await this.$store.dispatch("coupon/createCoupon", data);
      this.$swal({
        title: "Success",
        text: "coupon added successfully!!",
        type: "success",
      });
    },
    
    async refreshCouponList() {
      await this.$store.dispatch(
        "coupon/couponCodeList",
        this.$store.getters["auth/getUserID"]
      );
    },
    
    async getCatalogName() {
      const catalogConfig = this.isTenant
        ? {
            action: "catalog/fetchTenantCatalogTree",
            getter: "catalog/GetTenantCatalogTree",
            filter: (obj) => !obj.isProductType && !obj.isMarket,
          }
        : {
            action: "catalog/fetchPartnerCatalogTree",
            getter: "catalog/GetPartnerCatalogTree",
            filter: (obj) => obj.isProductType && !obj.isMarket,
          };
      
      await this.$store.dispatch(catalogConfig.action);
      const result = this.$store.getters[catalogConfig.getter];
      
      this.catalogList = result
        .filter(catalogConfig.filter)
        .map((c) => ({ text: c.name, value: c._id }))
        .reverse();
    },
    
    async itemCatalogSelected(catalogId) {
      this.itemsList = [];
      
      const condition = {
        catalogId: catalogId.value,
      };
      
      if (!this.isTenant) {
        condition.provider = this.$store.getters["auth/getUserID"];
      }
      
      const data = await this.$store.dispatch("item/fetchItemsByCatalog", condition);
      
      this.itemsList = this.extractItemsList(data.response);
    },
    
    extractItemsList(items) {
      const list = [];
      
      items.forEach((item) => {
        const nameAttribute = item.string_attributes.find(
          (attr) => attr.attribute_name === "Name"
        );
        
        if (nameAttribute) {
          list.push({
            text: nameAttribute.attribute_value,
            value: item._id,
          });
        }
      });
      
      return list;
    },
    
    onchangeItem() {
      // Placeholder for item change handler
    },
  },
};
</script>
<style scoped>
.custom-transform-class {
  text-transform: uppercase;
}

.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}

.myDIV:hover + .hide {
  display: block;
  position: absolute;
}

.hide {
  display: none;
  font-size: 11px;
}

.help-icon {
  color: #727cf5;
}

.wide-button {
  width: 100px;
  height: 35px;
}
</style>
